import { FC } from 'react';
import { useRecoilValue } from 'recoil';
import { Props } from './type';
import DeviceManager from '@/components/util/deviceManager';
import { translationDataState } from '../../../../store';
import { Root, Header } from './styled';
import Icon from '@/units/Icon';

export const BannerHorizontalViewOnly: FC<Props & { children?: any }> = ({ show, onClose }) => {
  const translation = useRecoilValue(translationDataState);
  if (!show) return null;
  const isMobile = DeviceManager.isMobile();
  const isHorMob = DeviceManager.isHorizontalMobileView();
  if (isMobile && !isHorMob) {
    return (
      <Root>
        <Header>
          <Icon.Close className="close-modal" onClick={onClose} fontSize="large" />
        </Header>
        <div className="game-book-no-content">
          {translation?.expGbNoContent || 'Available only for horizontal view'}
        </div>
        <img className="game-book-gif" src="/experience/mobile.gif" alt="Screen orientation" />
      </Root>
    );
  }
  return null;
};
